import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'react-intl';

import styles from './GovernmentNumbersBody.module.less';

const messages = defineMessages({
  noContent: {
    id: 'This block will be displayed once the title or subtitle and at least two index entries have been filled in',
    defaultMessage:
      'This block will be displayed once the title or subtitle and at least two index entries have been filled in',
  },
});
const getIndexs = (
  index1Value,
  index1Description,
  index2Value,
  index2Description,
  index3Value,
  index3Description,
  index4Value,
  index4Description,
) => {
  const index1 = {
    value: index1Value?.trim(),
    description: index1Description?.trim(),
  };

  const index2 = {
    value: index2Value?.trim(),
    description: index2Description?.trim(),
  };

  const index3 = {
    value: index3Value?.trim(),
    description: index3Description?.trim(),
  };

  const index4 = {
    value: index4Value?.trim(),
    description: index4Description?.trim(),
  };

  return [
    ...(index1.value && index1.description ? [index1] : []),
    ...(index2.value && index2.description ? [index2] : []),
    ...(index3.value && index3.description ? [index3] : []),
    ...(index4.value && index4.description ? [index4] : []),
  ];
};

const show = (title, subtitle, indexs) => {
  return (title || subtitle) && indexs.length > 1;
};

const GovernmentNumbersBody = (props) => {
  const intl = useIntl();
  const { data } = props;
  const {
    title,
    subtitle,
    buttonLabel,
    buttonUrl,
    index1Value,
    index1Description,
    index2Value,
    index2Description,
    index3Value,
    index3Description,
    index4Value,
    index4Description,
  } = data;

  const indexs = getIndexs(
    index1Value,
    index1Description,
    index2Value,
    index2Description,
    index3Value,
    index3Description,
    index4Value,
    index4Description,
  );

  if (!show(title, subtitle, indexs)) {
    return (
      <div className="text-danger text-center">
        {intl.formatMessage(messages.noContent)}
      </div>
    );
  }

  return (
    <div className={`full-width ${styles.block}`}>
      <div className="ui container">
        {title ? (
          <h2 className="text-center text-pure-0 mt-0 mb-2">{title}</h2>
        ) : null}
        {subtitle ? (
          <p className="text-center text-pure-0 mt-0 mb-2">{subtitle}</p>
        ) : null}

        <ul className={styles.grid}>
          {indexs.map((index, idx) => (
            <li key={idx}>
              <div className={styles.val}>{index.value}</div>
              <div className={styles.label}>{index.description}</div>
            </li>
          ))}
        </ul>
        <div className="text-center mt-7">
          {buttonLabel && buttonUrl ? (
            <UniversalLink
              item={{ '@id': buttonUrl }}
              className={`br-button ${styles.button}`}
            >
              {buttonLabel}
            </UniversalLink>
          ) : null}
        </div>
      </div>{' '}
    </div>
  );
};

GovernmentNumbersBody.propTypes = {
  isEditMode: PropTypes.bool,
};

export default GovernmentNumbersBody;
